
export const RECEIVER_COOKIE_KEY = 'f-rcv-cookie'


export const ETC_SEPARATOR = "$%"


export const RECEIVE_ALL_CHECKED_COLOR = '#757de8'
export const RECEIVE_PARTIAL_CHECKED_COLOR = '#ffcdd2'

// export const CENTER_ID_SC = 1
// export const CENTER_ID_YS = 2


// export const HISTORY_TYPE_RECV = '0'
// export const HISTORY_TYPE_NAVER_RELEASE = '1000'
// export const HISTORY_TYPE_COUPANG_RELEASE = '1001'
// export const HISTORY_TYPE_EDIT = '9000'


export const HISTORY_TYPE_RECV = 0
export const HISTORY_TYPE_EDIT = 1
export const HISTORY_TYPE_STORE_FIX = 2
export const HISTORY_TYPE_GSHEET_EDIT = 3 // GOOGLE SHEET SCRIPT 에서 입고 처리 하는경우
export const HISTORY_TYPE_EDIT_CENTER = 4
export const HISTORY_TYPE_EDIT_OUT = 5
export const HISTORY_TYPE_EDIT_NAVER = 6
export const HISTORY_TYPE_EDIT_COUPANG = 7
export const HISTORY_TYPE_NAVER_CENTER_CHANGED = 20
export const HISTORY_TYPE_COUPANG_CENTER_CHANGED = 21
export const HISTORY_TYPE_NAVER_RELEASE = 1000
export const HISTORY_TYPE_COUPANG_RELEASE = 1001


export const FULL_SEARCH_BAR_TRIGGER_WIDTH = 900;
export const MOBILE_WIDTH_THRESHOLD = 700;
export const MIN_WIDTH_THRESHOLD = 1100;


export const EXPIRE_DATE_MAX_YEAR = 6